const styles = theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '70vh',
    '& > * + *': {
      marginLeft: theme.spacing(2),
    },
  },
})

export default styles
